import React, { useContext, useEffect, useRef, useState } from "react";

import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";

import {
	Dialog, DialogActions,
	DialogContent,
	DialogTitle,
	TextField,
	Button,
	withWidth,
} from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import TransferTicketModal from "../TransferTicketModal";
import toastError from "../../errors/toastError";
import { Can } from "../Can";
import { AuthContext } from "../../context/Auth/AuthContext";
import { toast } from "react-toastify";
import BackdropLoading from "../BackdropLoading";
import InputMask from "react-input-mask";
import { InfoOutlined } from "@material-ui/icons";

const TicketOptionsMenu = ({ ticket, menuOpen, handleClose, anchorEl }) => {
	const [confirmationOpen, setConfirmationOpen] = useState(false);
	const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
	const [quantidadeModalOpen, setQuantidadeModalOpen] = useState(false);
	const [quantidade, setQuantidade] = useState(10);
	const [horarioBusca, setHorarioBusca] = useState("00:10");
	const isMounted = useRef(true);
	const { user } = useContext(AuthContext);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		return () => {
			isMounted.current = false;
		};
	}, []);

	const handleDeleteTicket = async () => {
		try {
			await api.delete(`/tickets/${ticket.id}`);
		} catch (err) {
			toastError(err);
		}
	};

	const handleOpenConfirmationModal = () => {
		setConfirmationOpen(true);
		handleClose();
	};

	const handleOpenTransferModal = () => {
		setTransferTicketModalOpen(true);
		handleClose();
	};

	const handleCloseTransferTicketModal = () => {
		if (isMounted.current) {
			setTransferTicketModalOpen(false);
		}
	};

	const handleOpenQuantidadeModal = () => {
		setQuantidadeModalOpen(true);
		handleClose();
	};

	const handleBuscarMensagens = async () => {

		if (!quantidade || Number(quantidade) <= 0) {
			toast.error("Informe uma quantidade válida.");
			return;
		}
		if (!horarioBusca || !/^\d{2}:\d{2}$/.test(horarioBusca)) {
			toast.error("Informe o horário no formato hh:mm.");
			return;
		}

		setQuantidadeModalOpen(false);
		setLoading(true);
		try {
			await api.post("/messages/fetchmessages", {
				ticketId: ticket.id,
				quantidade: Number(quantidade),
				horarioBusca: horarioBusca
			});
			toast.success("Mensagens buscadas e salvas com sucesso!");

			setTimeout(() => { window.location.reload(); }, 1000);

		} catch (err) {
			toastError(err);
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
			{loading && <BackdropLoading />}

			<Menu
				id="menu-appbar"
				anchorEl={anchorEl}
				getContentAnchorEl={null}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
				keepMounted
				transformOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
				open={menuOpen}
				onClose={handleClose}
			>
				<MenuItem onClick={handleOpenTransferModal}>
					{i18n.t("ticketOptionsMenu.transfer")}
				</MenuItem>
				<Can
					role={user.profile}
					perform="ticket-options:deleteTicket"
					yes={() => (
						<MenuItem onClick={handleOpenConfirmationModal}>
							{i18n.t("ticketOptionsMenu.delete")}
						</MenuItem>
					)}
				/>
				<MenuItem onClick={handleOpenQuantidadeModal}>
					{i18n.t("Buscar Mensagens")}
				</MenuItem>
			</Menu>

			<Dialog maxWidth='xs' open={quantidadeModalOpen} onClose={() => setQuantidadeModalOpen(false)}>
				<DialogTitle>Buscar Mensagens</DialogTitle>
				<DialogContent dividers gap={2} style={{ display: 'flex', flexDirection: 'column' }}>

					<TextField
						autoFocus
						margin="dense"
						label="Quantidade"
						type="number"
						variant="outlined"
						value={quantidade}
						onChange={e => setQuantidade(e.target.value)}
						fullWidth
						required
					/>

					<InputMask
						mask="99:99"
						value={horarioBusca}
						onChange={e => setHorarioBusca(e.target.value)}
						maskplaceholder="hh:mm"
					>
						{(inputProps) => (
							<TextField
								{...inputProps}
								margin="dense"
								label="Horas atrás (hh:mm)"
								variant="outlined"
								fullWidth
								required
							/>
						)}
					</InputMask>
					<div style={{
						marginTop: '8px',
						padding: '8px 12px',
						backgroundColor: '#e9f3ffff',
						color: '#2576d2',
						borderRadius: '6px',
						display: 'flex',
						alignItems: 'flex-start',
						gap: '8px'
					}}>
						<InfoOutlined style={{ fontSize: 18, marginTop: 2 }} />
						<span>
							As mensagens buscadas serão as mais recentes do contato do Ticket, respeitando a quantidade e o horário informados.
							<br />
							<strong>Exemplo:</strong> Se hoje é 15/06/2024 e você informar 30 na quantidade e 00:10 nas horas, serão buscadas as 30 últimas mensagens a partir de 15/06/2024 10 minutos atrás do horário atual, para o Contato do Ticket.
						</span>
					</div>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => setQuantidadeModalOpen(false)} color="#616161" variant="outlined">
						Cancelar
					</Button>
					<Button onClick={handleBuscarMensagens} color="primary" variant="contained">
						Buscar
					</Button>
				</DialogActions>
			</Dialog>

			<ConfirmationModal
				title={`${i18n.t("ticketOptionsMenu.confirmationModal.title")}${ticket.id
					} ${i18n.t("ticketOptionsMenu.confirmationModal.titleFrom")} ${ticket.contact.name
					}?`}
				open={confirmationOpen}
				onClose={setConfirmationOpen}
				onConfirm={handleDeleteTicket}
			>
				{i18n.t("ticketOptionsMenu.confirmationModal.message")}
			</ConfirmationModal>

			<TransferTicketModal
				modalOpen={transferTicketModalOpen}
				onClose={handleCloseTransferTicketModal}
				ticketid={ticket.id}
				ticketWhatsappId={ticket.whatsappId}
			/>
		</>
	);
};

export default TicketOptionsMenu;
